import React from 'react';
import { DollarSignIcon, InfoIcon, CheckCircleIcon, AlertTriangleIcon } from 'lucide-react';
const fullDayFees = [{
  label: 'Rental Fee',
  amount: '$2,000'
}, {
  label: 'Setup Day Before',
  amount: '$350'
}, {
  label: 'Clean Up Day After',
  amount: '$350'
}, {
  label: 'Keg Beer Tapper Cleaning Fee',
  amount: '$100'
}, {
  label: 'Security Deposit',
  amount: '$750'
}];
export function RentalRates() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-554">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-555">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-556">
          Rental Rates
        </h2>

        {/* Full Day - Non Member */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border mb-6" style={{
        borderColor: '#ede9e0'
      }} data-id="element-557">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-558">
            <DollarSignIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-559" />
            <h3 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-560">
              Full Day Hall Rental — Non-Member
            </h3>
          </div>
          <div className="overflow-x-auto" data-id="element-561">
            <table className="w-full text-left border-collapse" data-id="element-562">
              <tbody data-id="element-563">
                {fullDayFees.map((fee, index) => <tr key={fee.label} className={index < fullDayFees.length - 1 ? 'border-b' : ''} style={{
                borderColor: '#ede9e0'
              }} data-id="element-564">
                    <td className="p-4 font-medium text-gray-800" style={{
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-565">
                      {fee.label}
                    </td>
                    <td className="p-4 font-bold text-right" style={{
                  color: '#1e3d2f',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-566">
                      {fee.amount}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Member Rates Note */}
        <div className="flex items-start gap-3 p-4 rounded-xl mb-6" style={{
        backgroundColor: '#f0f7f3',
        border: '1px solid #1e3d2f'
      }} data-id="element-567">
          <InfoIcon size={20} className="flex-shrink-0 mt-0.5" style={{
          color: '#1e3d2f'
        }} data-id="element-568" />
          <p className="text-sm font-medium" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-569">
            <strong data-id="element-570">FLSC Members:</strong> Discounted member rates are
            available. Members must be logged in to view member pricing.
          </p>
        </div>

        {/* Partial Day */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-571">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-572">
            <DollarSignIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-573" />
            <h3 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-574">
              Partial Day Hall Rental
            </h3>
          </div>
          <div className="p-6 space-y-3" data-id="element-575">
            <div className="flex items-start gap-3" data-id="element-576">
              <CheckCircleIcon size={18} className="flex-shrink-0 mt-0.5" style={{
              color: '#1e3d2f'
            }} data-id="element-577" />
              <p className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-578">
                Rental fee — <strong data-id="element-579">Call Lease Agent</strong> for pricing
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-580">
              <AlertTriangleIcon size={18} className="flex-shrink-0 mt-0.5" style={{
              color: '#c8a84b'
            }} data-id="element-581" />
              <p className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-582">
                Partial Day Rentals are <strong data-id="element-583">not available</strong> on
                Friday, Saturday, or Sunday
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-584">
              <DollarSignIcon size={18} className="flex-shrink-0 mt-0.5" style={{
              color: '#1e3d2f'
            }} data-id="element-585" />
              <p className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-586">
                <strong data-id="element-587">$750</strong> security deposit required on all rentals
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}